import { Typography, useTheme } from "@mui/material";


interface IAsteriskTextProps {
    text: string;
    color?: string;
}

function AsteriskText({ ...props }: IAsteriskTextProps) {
    const theme = useTheme();
    const textColor = props.color || theme.palette.error.main;

    return (
        <Typography component="span" color={textColor}>
            *{props.text}
        </Typography>
    );
}

export default AsteriskText;